import React, { useState } from "react";
import clsx from "clsx";
import { makeStyles } from '@material-ui/styles';
import moment from "moment";

import HtmlContent from "../components/html_content.js";
import FormFields from "../../base/form/form_fields.js";
import Checkbox from "../inputs/checkbox.js";
import Button from "../buttons/button.js";

import I18n from "../i18n.js";

import withCurrentUser from "../../hocs/with_current_user.js";
import withShowToast from "../../hocs/with_show_toast.js";
import { compose } from 'redux';

import { SupportMessageModel } from "../../models/support/support_message_model.js";

import CreateMessageUseCase from "../../use_cases/support/messages/create_message_use_case.js";

import Routes from "../../web/routes.js";

const blockStyles = makeStyles(theme => ({
  root: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  text: {
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: theme.typography.fontWeightRegular,
    marginBottom: "40px",
    ['@media (max-width: 768px)']: {
      fontSize: "12px",
      lineHeight: "18px",
      marginBottom: "28px",
    },
  },
  agreementRow: {
    margin: "40px 0px 30px",
    alignItems: "start",
    ['@media (max-width: 768px)']: {
      margin: "20px 0px 20px"
    },
    "& .MuiCheckbox-root": {
      marginTop: "-9px"
    }
  },
  agreementText: {
    fontSize: "16px",
    ['@media (max-width: 768px)']: {
      fontSize: "11px",
    },
    "& a": {
      color: `${theme.palette.black} !important`
    }
  },
  submit: {
    display: "block",
    fontSize: "20px",
    margin: "30px auto 0",
    maxWidth: "410px",
    padding: "8px 20px",
    width: "100%",
    ['@media (max-width: 768px)']: {
      margin: "20px auto 0",
      fontSize: "18px",
      padding: "10px 20px",
    }
  }
}));

const ContactsForm = (props) => {
  const classes = blockStyles();
  
  const { className, showSuccessMessage, showServerErrorIfNeed } = props;

  const defaultMessage = () => {
    const { currentUser } = props;
    if(!currentUser) {
      return {};
    }
    return {
      email: currentUser.email,
      name: currentUser.fullName
    };
  }

  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState(defaultMessage());
  const [errorData, setErrorData] = useState(undefined);
  const [key, setKey] = useState(moment().unix())

  const onItemChange = (newMessage) => {
    const msg = {
      ...message,
      ...newMessage
    };
    setMessage(msg);
  }

  const onChecked = (value) => {
    const newMessage = {
      ...message,
      agreeTermsAndConditions: value
    };
    setMessage(newMessage);
  }

  const onSubmit = (event) => {
    event.preventDefault();
    setSubmitting(true);
    setErrorData(undefined);
    CreateMessageUseCase.execute(message)
    .then(() => {
      setSubmitting(false);
      setMessage(defaultMessage());
      showSuccessMessage(I18n.t("component.contact_form.success"));
      setKey(moment().unix());
    })
    .catch((result) => {
      const { errorData } = result;
      setErrorData(errorData);
      setSubmitting(false);
      showServerErrorIfNeed(result);
    });
  }

  const formFields = SupportMessageModel.formFields({item: message});

  return (
    <div className = { clsx(classes.root, className) } >
      <form onSubmit = { onSubmit } >
        <FormFields formFields = { formFields } 
                    item = { message }
                    errorData = { errorData } 
                    onItemChange = { onItemChange }
                    key = { key } />
        <Checkbox checked = { message.agreeTermsAndConditions } 
                  onChange = { onChecked }
                  className = { classes.agreementRow }
                  displayName = { 
                    <HtmlContent className = { classes.agreementText }>
                      { I18n.t("component.contact_form.agreement", {terms_and_conditions: Routes.termsAndConditions(), data_protection: Routes.dataProtection()}) }
                    </HtmlContent>
                  }/>
        <Button className = { classes.submit }
                type = { "submit" }
                disabled = { submitting || !message.agreeTermsAndConditions } >
          { I18n.t("action.send_message") }
        </Button>
      </form>
    </div>
  );
};

export default compose(withShowToast, withCurrentUser)(ContactsForm);
